import { render, staticRenderFns } from "./GroupRegisterAndLunch.vue?vue&type=template&id=549d669b&"
import script from "./GroupRegisterAndLunch.vue?vue&type=script&lang=js&"
export * from "./GroupRegisterAndLunch.vue?vue&type=script&lang=js&"
import style0 from "./GroupRegisterAndLunch.vue?vue&type=style&index=0&id=549d669b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports